export const ROUTES = {
  home: "/",
  devicePanel: "/device-panel",
  settings: "/settings",
  device_settings: "/device-settings",
  schedule: "/schedule",
  gallery: "/gallery",
  traps_and_locations: "/traps-locations",
  specimen_catalog: "/specimen-catalog",
  admin: "/admin"
};
